import React from "react";

// Navigate
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

// Fetch
import { loginByStaffCode } from "@/fetch/fetchLogin";

// CSS
import "@/styles/page/loginPage.css";

// Mui Styles
import { StyledButton } from "@/styles/mui/globalStyles";

// Mui
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

// Mui Icon
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Snackbar
import { setUser } from "@/features/userSlice";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";

//Api
import api from "@/lib/Api";
import pharmaGoodApi from "@/lib/PharmaGoodApi";

function Transition(props) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const LoginPage = () => {
  // Navigate
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slug } = useParams();

  // States
  const [staffCode, setStaffcode] = React.useState(null);
  const [password, setPassword] = React.useState(null);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Fetch
  const login = async () => {
    await loginByStaffCode(staffCode, password).then((data) => {
      if (data && data.results) {
        if (parseInt(data.staff.role_types_id) === 3) {
          setAlertMessage("您沒有權限進入");
          setSnackOpen(true);
          return false;
        }
        const userData = {
          token: data.token,
          refreshToken: data.refreshToken,
          userRole: data.staff.role_types_id,
          userUrl: data.staff.url,
          departmentId: data.staff.department_id,
        };

        dispatch(setUser(userData));
        api.setToken(data.token);
        pharmaGoodApi.setToken(data.token);
        navigate("/");
      } else {
        setAlertMessage("請輸入正確的員工編號或密碼");
        setSnackOpen(true);
      }
    });
  };

  React.useEffect(() => {
    if (slug === "tokenExpired") {
      setAlertMessage(`登入已超時，請重新登入`);
      setSnackOpen(true);
    }
  }, []);

  return (
    <div className="loginContainer">
      <Snackbar
        TransitionComponent={Transition}
        open={snackOpen}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        autoHideDuration={6000}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <CssBaseline />
      <div className="loginBox">
        <Stack spacing={2}>
          <img src={"/image/logo.png"} alt="logo" />
          <div className="btnContainer">
            <TextField
              sx={{ width: "100%" }}
              id="login-username"
              placeholder="員工編號"
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
              onChange={(event) => setStaffcode(event.target.value)}
            />
          </div>
          <div className="btnContainer">
            <TextField
              sx={{ width: "100%" }}
              id="login-password"
              placeholder="密碼"
              variant="standard"
              type={showPassword ? "text" : "password"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <StyledButton variant="contained" size="small" onClick={login}>
            <Typography variant="subtitle1" noWrap component="div">
              登入
            </Typography>
          </StyledButton>
        </Stack>
      </div>
    </div>
  );
};

export default LoginPage;
